import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=03398ff7&scoped=true"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"
import style0 from "./EditForm.vue?vue&type=style&index=0&id=03398ff7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03398ff7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03398ff7')) {
      api.createRecord('03398ff7', component.options)
    } else {
      api.reload('03398ff7', component.options)
    }
    module.hot.accept("./EditForm.vue?vue&type=template&id=03398ff7&scoped=true", function () {
      api.rerender('03398ff7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Fittings/FittingsRecord/EditForm.vue"
export default component.exports